import Team from "@mapmycustomers/shared/types/Team";

import TargetType from "@app/enum/dashboard/TargetType";
import { isMember } from "@app/store/iam/util";
import { GoalConfiguration } from "@app/types/dashboard/CardConfiguration";
import Scope from "@app/types/dashboard/Scope";
import loggingService from "@app/util/logging";

const getGoalAmount = (
  goalConfiguration: GoalConfiguration | undefined,
  scope: Scope,
  teams: Team[]
): number | undefined => {
  if (!goalConfiguration?.enabled) {
    return undefined;
  }

  const { target = 0, type = TargetType.TEAM } = goalConfiguration ?? {};

  // for org level and non-team users (including owners), this is just a target
  if (!scope.teamId || !scope.userId) {
    return target;
  }

  const team = teams.find(({ id }) => id === scope.teamId);
  if (!team?.users.length) {
    // shouldn't really happen, but let's catch this
    loggingService.warning(`Wasn't able to find a team for given scope`, { scope, teams });
    return undefined;
  }

  switch (type) {
    case TargetType.INDIVIDUAL: {
      const { defaultTarget, individualUserGoals } = goalConfiguration ?? {};
      return individualUserGoals?.[scope.userId] ?? defaultTarget ?? 0;
    }
    case TargetType.MEMBERS: {
      const membersCount = team.users.filter((user) => isMember(user)).length;
      return membersCount > 0 ? Math.ceil(target / membersCount) : 0;
    }
    default:
      return goalConfiguration.personal ? target : Math.ceil(target / team.users.length);
  }
};

export default getGoalAmount;
